export enum DEBUG_DOMAIN {
  CF_DEBUG = 'cfDebug',
}

export const DEBUG_DOMAIN_KEY = 'debug';
